<template>
  <div class="laboratoryManagement">
    <header>
      <div class="title">管理痛点</div>
      <ManagementPainPoints :list="MANAGE_LIST"></ManagementPainPoints>
    </header>
    <main>
      <div class="title">方案亮点</div>
      <TabLights :list="LIGHTS"></TabLights>
    </main>
    <section class="wow animate__animated animate__fadeIn">
      <div class="title">方案优势</div>
      <Advantage :list="TECHNICAL_CAPACITY"></Advantage>
      <div class="title">业务过程控制</div>
      <div class="lc-title">考前准备、双模式考试、考后认证与优化</div>
      <div class="lc">
        <div class="lcList">
          <div class="lc-item maria" v-for="item in LC_LIST" :key="item.key">
            <div class="lc-img" :style="{ backgroundColor: item.color }">
              <OssImg :src="item.imgPath" />
            </div>

            <div class="lc-text">
              <div class="lc-t">{{ item.text }}</div>
              <div class="lc-desc">{{ item.desc }}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <footer class="wow animate__animated animate__fadeIn">
      <div class="title">服务支持</div>
      <div class="friends">
        <div
          class="friendItem"
          v-for="(item, index) in serviceList"
          :key="index"
          @click="handleSeeDetail"
        >
          <el-card class="maria">
            <template #default>
              <div class="f-img">
                <OssImg :src="item.imgPath" style="width: 100%" />
              </div>
              <div class="f-title">{{ item.name }}</div>
              <div class="f-desc">
                {{item.subTitle}}
              </div>
            </template>
          </el-card>
        </div>
        <div class="btn" @click="navTo('/customerCase')">更多案例</div>
      </div>
    </footer>
  </div>
</template>

<script setup>
import { ref,onMounted } from "vue";
import ManagementPainPoints from "./components/ManagementPainPoints.vue";
import TabLights from "./components/TabLights.vue";
import Advantage from "./components/Advantage.vue";
import { navTo } from "@/utils/util";

import { WOW } from 'wowjs'
onMounted(()=>{
  const wow = new WOW();
  wow.init();
})
const MANAGE_LIST = ref([
  {
    iconPath: "images/solution/trainingAdmission/icon1.png",
    title: "数据价值未挖",
    desc: "试结果未深度分析，无法为后续培训优化提供参考。准入考试系统自动统计高频错题、低分环节，生成能力短板报告，精准定位人员薄弱点，助力针对性改进培训内容与方式",
    key: 0,
  },
  {
    iconPath: "images/solution/trainingAdmission/icon2.png",
    title: "培训考试脱节",
    desc: "传统模式下培训与考试相互独立，培训效果无法有效检验。准入考试与培训课程紧密衔接，根据培训内容定制考试题目，以考促学，确保知识吸收转化",
    key: 1,
  },
  {
    iconPath: "images/solution/trainingAdmission/icon3.png",
    title: "缺乏动态更新",
    desc: "考试内容长期不变，无法适应实验室新设备、新法规、新风险的变化。准入考试建立动态题库，实时更新试题，保证考试内容与实际安全需求同步",
    key: 2,
  },
  {
    iconPath: "images/solution/trainingAdmission/icon4.png",
    title: "证书管理混乱",
    desc: "纸质证书易丢失、造假，难以快速核验真伪。准入考试颁发电子证书，与管理系统绑定，支持随时在线查验，便于证书的统一管理与追溯",
    key: 3,
  },
]);
const LIGHTS = ref([
  {
    tabText: "动态化管理模式",
    title: "动态化管理模式",
    desc: "打造统一线上考试平台，支持多校区、多分支机构跨区域同步考核，确保标准一致。建立动态题库更新机制，实时纳入新设备操作规范、最新安全法规等内容，让考试始终贴合实验室实际需求。电子证书与管理系统联动，便于快速查验、追溯，大幅提升证书管理效率与安全性",
    imgPath: "images/UIV2/solution6.png",
    key: 0,
  },
  {
    tabText: "分层定制化考试内容",
    title: "分层定制化考试内容",
    desc: "针对实验室不同岗位（如管理员、实验人员、科研人员），定制差异化考试内容。管理员侧重合规管理、库存调度；实验人员聚焦设备操作、危化品使用；科研人员关注风险预判与应急预案，实现 “精准施考”，强化岗位安全胜任力",
    imgPath: "images/UIV2/solution7.png",
    key: 1,
  },
  {
    tabText: "数据驱动持续优化机制",
    title: "数据驱动持续优化机制",
    desc: "通过考试大数据分析，生成实验室安全能力热力图，直观呈现不同团队、个人的薄弱环节。结合行业安全事故案例库，反向优化培训课程与考试重点，形成 “考试发现问题 - 培训补足短板 - 再考验证效果” 的循环改进体系，持续提升实验室整体安全水平",
    imgPath: "images/UIV2/solution8.png",
    key: 2,
  },
]);

const TECHNICAL_CAPACITY = ref([
  {
    title: "多系统无缝集成",
    desc: "可与实验室信息管理系统（LIMS）、安防监控系统深度对接，实现考试数据、人员权限、安全监控信息互通，构建一体化安全管理生态，提升实验室整体运营效率",
    imgPath: "images/solution/trainingAdmission/big_icon1.png",
    key: 0,
  },
  {
    title: "移动化便捷学习",
    desc: "配套移动端学习 APP，支持碎片化学习，人员可随时随地观看安全知识微课、参与模拟考试、接收培训提醒，打破时间与空间限制，提升学习灵活性",
    imgPath: "images/solution/trainingAdmission/big_icon2.png",
    key: 1,
  },
  {
    title: "风险预警前置化",
    desc: "通过分析考试中暴露的高频错误操作、薄弱知识领域，提前预判实验室潜在安全风险，主动推送预防措施与改进建议，将安全隐患扼杀在萌芽阶段",
    imgPath: "images/solution/trainingAdmission/big_icon3.png",
    key: 2,
  },
  {
    title: "人才梯队建设",
    desc: "根据考试成绩与能力评估，建立实验室人才安全能力档案，为人员晋升、评优提供参考依据，助力打造高素质、专业化的实验室安全人才梯队",
    imgPath: "images/solution/trainingAdmission/big_icon4.png",
    key: 3,
  },
  {
    title: "国际标准兼容",
    desc: "考试内容与国际实验室安全标准（如 ISO 17025）接轨，满足跨国科研合作、国际认证等需求，提升实验室的国际化竞争力",
    imgPath: "images/solution/trainingAdmission/big_icon5.png",
    key: 4,
  },
  {
    title: "社会资源联动",
    desc: "与消防、安监等外部机构合作，将专业救援人员的实战经验融入考试案例与培训内容，同时为人员提供与外部专家交流学习的机会，拓宽安全视野",
    imgPath: "images/solution/trainingAdmission/big_icon6.png",
    key: 5,
  },
]);
const LC_LIST = ref([
  {
    imgPath: "images/solution/trainingAdmission/control1.png",
    text: "考前准备阶段",
    desc: "根据实验室岗位类型（管理员、实验人员等）及安全管理需求，生成个性化题目，人员通过门户端、移动端完成线上课程学习",
    key: 0,
    color: "#efeeff",
  },
  {
    imgPath: "images/solution/trainingAdmission/control2.png",
    text: "考试执行阶段",
    desc: "考生通过统一身份认证、账密等多种验证方式进入考试，实时监控答题状态，异常行为自动预警，确保考试规范性",
    key: 1,
    color: "#eef7ff",
  },
  {
    imgPath: "images/solution/trainingAdmission/control3.png",
    text: "考后管理阶段",
    desc: "统自动批改理论试卷，结合实操评分细则生成综合成绩，合格者颁发电子证书，并同步开放对应实验室设备权限。通过大数据分析考生错题、薄弱环节，生成安全能力报告与风险预警，推送针对性培训建议",
    key: 2,
    color: "#fffaee",
  },
]);
const serviceList = ref([
  {
    imgPath: "images/solution/trainingAdmission/training1.png",
    name: "三峡大学",
    subTitle: "建立实验室安全学习准入考试平台，实现考试学习一体化管理，累计参考人次10w+",
  },
  {
    imgPath: "images/solution/trainingAdmission/training2.png",
    name: "郑州航空学院",
    subTitle: "安全培训准入板块，多种组卷方式灵活使用，适用各学院、专业、人员+",
  },
  {
    imgPath: "images/solution/trainingAdmission/training3.png",
    name: "兰州工业学院",
    subTitle: "多维度统计满足各分段、各人员、各错题区间统计结果，支持数据追溯，助力优化考试",
  },
]);
</script>

<style lang="scss" scoped>
.laboratoryManagement {
  $titleSize: 60px;
  font-family: "PingFang SC";
  .title {
    color: rgba(33, 33, 33, 1);
    font-weight: 500;
    font-size: $titleSize;
    text-align: center;
  }
  main {
    margin: 56px;
  }
  section {
    .lc-title {
      color: #424242;
      text-align: center;
      font-weight: 600;
      font-size: 32px;
      margin: 24px 0px 50px 0px;
    }
    .lc {
      .lcList {
        display: flex;
        gap: 24px;
        .lc-item {
          box-sizing: border-box;
          padding: 16px;
          width: 100%;
          height: 170px;
          border-radius: 16px;
          background: #ffffff;
          display: flex;
          align-items: center;
          gap: 10px;
          .lc-text {
            flex: 1;
            .lc-t {
              color: #424242;
              font-weight: 500;
              font-size: 16px;
            }
            .lc-desc {
              margin-top: 10px;
              color: #888888;
              font-weight: 500;
              font-size: 14px;
            }
          }
          .lc-img {
            width: 80px;
            height: 80px;
            border-radius: 80px;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
      }
    }
  }
  footer {
    margin-top: 56px;
    .friends {
      margin-top: 32px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .friendItem {
        width: 32%;
        height: 334px;
        margin-bottom: 32px;
        cursor: pointer;
        .f-img {
          width: 100%;
          height: 220px;
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
            // &:hover {
            //   transform: scale(1.1);
            //   transition: all 1s ease-in-out;
            // }
          }
        }
        .f-title {
          color: #424242;
          font-size: 16px;
          font-weight: 500;

          margin: 13px 0px;
          padding: 0px 16px;
        }
        .f-desc {
          color: #888888;
          font-weight: 500;
          font-size: 14px;
          padding: 0px 16px;
        }
        .el-card {
          border-radius: 16px;
          height: 334px;
          :deep(.el-card__body) {
            padding: 0px;
          }
        }
      }
    }
    .btn {
      margin: 32px auto 126px;
      width: 97px;
      height: 40px;
      border-radius: 8px;
      background: #32A89E;
      color: #ffffff;
      font-weight: 600;
      font-size: 16px;
      text-align: center;
      line-height: 35px;
      cursor: pointer;
    }
  }
}
</style>
